import React from 'react';
import { motion } from 'framer-motion';
import { Swords, Download } from 'lucide-react';
import { DisputesList } from '../components/disputes/DisputesList';
import { useDisputesStore } from '../stores/disputesStore';
import { useLanguage } from '../contexts/LanguageContext'; // Assuming you have a LanguageContext
import { exportDisputes } from '../utils/exportDisputes';
import toast from 'react-hot-toast';

export const DisputesPage = () => {
  const { disputes } = useDisputesStore();
  const { translations } = useLanguage(); // Access translations from the context

  const handleExport = () => {
    const success = exportDisputes(Object.values(disputes));
    if (success) {
      toast.success(
        translations?.disputesPage?.exportSuccess || 'Disputes exported successfully'
      );
    } else {
      toast.error(
        translations?.disputesPage?.exportError || 'Failed to export disputes'
      );
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center gap-3"
        >
          <div className="p-2 bg-red-50 rounded-lg">
            <Swords className="text-red-500" size={24} />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              {translations?.disputesPage?.header || 'Disputes'}
            </h1>
            <p className="text-gray-500 mt-1">
              {translations?.disputesPage?.description ||
                'Managing disputes between organizers over pilgrim ownership'}
            </p>
          </div>
        </motion.div>

        <div className="flex gap-3">
          <button
            onClick={handleExport}
            className="flex items-center gap-2 px-4 py-2 bg-primary-50 text-primary-600 
                     rounded-lg hover:bg-primary-100 transition-colors"
          >
            <Download size={20} />
            <span>{translations?.disputesPage?.export || 'Export Report'}</span>
          </button>
        </div>
      </div>

      {/* Disputes List */}
      <DisputesList />
    </div>
  );
};
